export enum STATUS_LOCKED {
  true = 1,
  false = 0,
}

export enum STATUS_KY_APPROVE {
  true = 1,
  false = 0,
}

export enum KY_DATA_APPROVED_SITE_MANAGER {
  false = 0,
  true = 1,
}

export enum KY_APPROVE_STATUS {
  DTC_APPROVE = 1,
  CM_APPROVE = 2,
}

export enum TIME_CHANGE_FLAG {
  NOT_CHANGE = 0,
  CHANGE = 1,
}
